import React from 'react';
import PropTypes from 'prop-types';

import { Icon } from '@edx/paragon';
import { Timelapse } from '@edx/paragon/icons';
import {
  injectIntl,
  defineMessages,
} from 'gatsby-plugin-react-intl';
import { intlShape } from '@prospectus/common/types/intlShape';

const messages = defineMessages({
  'prospectus.course.snapshot.course-weeks.value': {
    id: 'prospectus.course.snapshot.course-weeks.value',
    defaultMessage: '{numWeeks} weeks',
    description: 'This describes the estimated number of weeks that are in a course.',
  },
});

function WeeksToComplete({
  hoursOfEffort,
  weeksToComplete,
  intl,
}) {
  return (
    <>
      <Icon src={Timelapse} />
      <div className="ml-3">
        <div className="h4 mb-0">
          {intl.formatMessage(messages['prospectus.course.snapshot.course-weeks.value'], { numWeeks: weeksToComplete })}
        </div>
        {hoursOfEffort !== ''
        && (
          <div className="small">
            {hoursOfEffort}
          </div>
        )}
      </div>
    </>
  );
}

WeeksToComplete.propTypes = {
  hoursOfEffort: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  weeksToComplete: PropTypes.number.isRequired,
  intl: intlShape.isRequired,
};

export default injectIntl(WeeksToComplete);
